import { BrowserRouter, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import './App.css';
import Browser from './components/browser/browser';
import Cadastro from './paginas/cadastro/cadastro';
import ConfirmacaoCadastro from './paginas/cadastro/confirmacaocadastro';
import Pdv from './paginas/gestao/pdv/pdv';
import Login from './paginas/login/login';
import { ZindexUtils } from './utils/zindexutils';

function App() {
  return (
    <>
      <ToastContainer position="top-right" style={{ zIndex: ZindexUtils.zIndexBar() + 1 }} />
      <div className="App">
        <BrowserRouter>
           
          <Routes>
            <Route path={`/cadastro`} element={<Cadastro />} />     
            <Route path={`/confirmacaocadastro`} element={<ConfirmacaoCadastro />} />     
            <Route path={`/login`} element={<Login />} />
            <Route path={`/`} element={<Login />} />
            <Route path={`/gestao`} element={<Browser />} />
            {/* <Route path={`/pdv`} element={<Pdv />} /> */}
            {/* <Route path={`/gestao`} element={<Nota />} /> */}

          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
